import React from 'react';
import { ArrowRight } from 'lucide-react';

interface HeroProps {
  onShopNow: () => void;
}

export const Hero: React.FC<HeroProps> = ({ onShopNow }) => {
  return (
    <div className="relative bg-gradient-to-r from-pink-50 to-purple-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center py-12">
          <div className="space-y-6">
            <h1 className="text-4xl md:text-6xl font-bold text-gray-900 leading-tight animate-fade-in">
              Welcome to{' '}
              <span className="text-pink-500">Shynerz Baby Shop</span>
            </h1>
            <p className="text-lg text-gray-600">
              Discover our curated collection of premium baby products. From adorable clothing to essential care items, we have everything your little one needs.
            </p>
            <button
              onClick={onShopNow}
              className="
                inline-flex items-center gap-2
                bg-pink-500 text-white
                px-8 py-4
                rounded-full
                text-lg font-semibold
                transform transition-all duration-300
                hover:bg-pink-600
                hover:scale-105
                hover:shadow-lg
                focus:outline-none focus:ring-2 focus:ring-pink-500 focus:ring-offset-2
                animate-pulse hover:animate-none
                group
              "
            >
              Shop Now
              <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
            </button>
          </div>
          <div className="relative">
            <img
              src="https://images.unsplash.com/photo-1519689680058-324335c77eba"
              alt="Happy baby"
              className="rounded-lg shadow-xl animate-float"
            />
            <div className="absolute -bottom-4 -right-4 bg-white p-4 rounded-lg shadow-lg animate-bounce-slow">
              <p className="text-pink-500 font-bold">Special Offer!</p>
              <p className="text-sm text-gray-600">Up to 30% off</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};